import { MeshPhongMaterial } from 'three';
import { ShaftSurfaceTexture } from '@app/react/const/type';

/**
 *
 * 標準  30
 * マット 0
 * メタリック50;
 */
export const changeShiny = (target: MeshPhongMaterial, type: ShaftSurfaceTexture): void => {
    switch (type) {
        case 'matte':
            target.shininess = 0;
            break;
        case 'metal':
            target.shininess = 50;
            break;
        default:
            target.shininess = 30;
            break;
    }

    target.needsUpdate = true;

    console.log('[3d] change target shininess', target.shininess);
};
